/** Digits only (no +), as required by https://wa.me/ */
export const OBA_WHATSAPP_WA_ME = "94766845050";

export function whatsappChatUrl(prefilledText?: string): string {
  const base = `https://wa.me/${OBA_WHATSAPP_WA_ME}`;
  const t = prefilledText?.trim();
  if (!t) return base;
  return `${base}?text=${encodeURIComponent(t)}`;
}
